<div class="bv-generator-history-empty">
  {{ "noPasswordsInList" | i18n }}
</div>
